import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NavBar = ({ installPrompt, onInstallClick }) => {
  const { currentUser, logout, isAuthenticated, userType } = useAuth();
  
  // Determine the correct dashboard URL based on user type
  const getDashboardUrl = () => {
    return userType === 'feeder' ? '/feeder' : '/dashboard';
  };
  
  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <Link to="/" className="navbar-logo">
          <img src="/logo192.png" alt="WellFed Cats Logo" />
          WellFed Cats
        </Link>
        
        <div className="navbar-links">
          <Link to="/">Home</Link>
          <Link to="/cats">Cats</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </div>
        
        <div className="navbar-auth">
          {isAuthenticated ? (
            <>
              {installPrompt && (
                <button 
                  className="install-button"
                  onClick={onInstallClick}
                >
                  Install App
                </button>
              )}
              <span className="user-greeting">Hi, {currentUser.name}</span>
              <Link to={getDashboardUrl()} className="button">Dashboard</Link>
              <button className="button secondary" onClick={logout}>Logout</button>
            </>
          ) : (
            <>
              {installPrompt && (
                <button 
                  className="install-button"
                  onClick={onInstallClick}
                >
                  Install App
                </button>
              )}
              <Link to="/login" className="button secondary">Login</Link>
              <Link to="/register" className="button">Register</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default NavBar; 